// Sistema simples de event emitter para atualizar a fila de imagens de satélite (CPTEC)

const listeners = new Set();

export const onSatelliteUpdate = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback); // retorna função para remover listener
};

export const emitSatelliteUpdate = () => {
  listeners.forEach(callback => callback());
};
